module.exports = __webpack_public_path__ + "img/symbol_7.65f220e0.png";